import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { ShieldCheck, Percent, Eye, MonitorSmartphone } from "lucide-react";

const iconMap = { ShieldCheck, Percent, Eye, MonitorSmartphone };

export default function WhyUs() {
  const whyUs = useContent().whyUs;
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center reveal">
          <div className="gold-rule mx-auto mb-6" />
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{whyUs.title}</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {whyUs.items.map((it) => {
            const Icon = iconMap[it.icon];
            return (
              <div key={it.title} className="group text-center px-4">
                <div className="w-16 h-16 rounded-full bg-[#faf8f4] border border-[#efe9dd] flex items-center justify-center mx-auto mb-5 transition-all duration-300 group-hover:bg-[#16233d]">
                  <Icon size={26} className="text-[#b08d57] transition-colors duration-300" />
                </div>
                <h3 className="font-serif-lux text-2xl text-[#16233d] mb-2">{it.title}</h3>
                <p className="text-[#5c6577] text-sm leading-relaxed">{it.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
